import ApiService from '@/common/api/api.service';

const EnderecoService = {
  async buscarInformacoesCep(cep) {
    const { data: endereco } = await ApiService.get(`Cep/${cep.replace("-", "")}`)

    const { data: paises } = await this.buscarNacionalidades();
    const paisId = paises.find(pais => pais.nome == 'Brasil')?.id;

    const { data: estados } = await this.buscarEstados(paisId);
    const estadoId = await estados.find(estado => estado.sigla == endereco.data.uf)?.id;
    
    const { data: municipios } = await this.buscarMunicipios(estadoId);
    const municipioId = municipios.find(municipio => municipio.nome == endereco.data.cidade)?.id;
    
    return {
      bairro: endereco.data.bairro,
      logradouro: endereco.data.logradouro,
      municipioId,
      municipioNome: endereco.data.cidade,
      estadoId,
      estadoNome: endereco.data.uf,
      paisId,
    };
  },
  async buscarNacionalidades() {
    let { data } = await ApiService.get(`SubDivisaoPais/obter-paises`);
    data.data = data.data.map((row) => ({
      ...row,
      value: row.id,
      text: row.nome,
    }));
    return data;
  },
  async buscarEstados(paisId) {
    let { data } = await ApiService.get(
      `SubDivisaoPais/obter-estados/${paisId}`
    );
    data.data = data.data.map((row) => ({
      ...row,
      value: row.id,
      text: row.nome,
    }));
    return data;
  },
  async buscarMunicipios(estadoId) {
    let { data } = await ApiService.get(
      `SubDivisaoPais/obter-municipios/${estadoId}`
    );
    data.data = data.data.map((row) => ({
      ...row,
      value: row.id,
      text: row.nome,
    }));
    return data;
  },

  async buscarMunicipio(naturalidadeId) {
    let { data } = await ApiService.get(
      `SubDivisaoPais/obter-municipio/${naturalidadeId}`
    );
    return data;
  },
};

export default EnderecoService;
